import React, { useEffect, useState } from 'react';
import './OrderHistory.css';
import NavBar from '../../components/NavBar/NavBar';
import ReviewModal from '../ReviewModal/ReviewModal';
import { useNavigate } from 'react-router-dom';
import NoData from '../../components/NoData/NoData';

const OrderHistory = () => {
  const [userOrders, setUserOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState(null);
const navigate = useNavigate()
  const handleWriteReview = (productId) => {
    setSelectedProductId(productId);
    setModalOpen(true); 
  };

  useEffect(() => {
    const fetchUserOrders = async () => {
      try {
        const response = await fetch('https://riymay.com/api/v1/user/orders', {
            method: "GET",
            headers: {
              Authorization: `Bearer ${localStorage.getItem("userToken")}`,
            },
         });
         const data = await response.json();
         if(data.message == "Invalid token"){
          localStorage.removeItem("userToken")
          navigate("/login")
        }
        if (!response.ok) {
          throw new Error('Failed to fetch orders');
        }
        setUserOrders(data.userOrders);
        
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUserOrders();
  }, []);



  if (loading) return <div className="order-history-loading">Loading...</div>;
  if (error) return <div className="order-history-error"><NoData /></div>;

  return (
    <>
      {/* <NavBar /> */}
   
    <div className="order-history-container">
      {userOrders && userOrders.length>0 ?
       (
         userOrders.length == 0 ? 
      (<p>No Orders Found</p>)
      :
      (
        userOrders.map((order, index) => (
        <div className="order-history-card" key={index}>

          {order && order.orderItems 
          
          ?
          ( order.orderItems.map((item) => (
            <div className="order-history-item" key={item._id}>
            <div className='order-history-image-product-text'>
              <div className='order-history-product-img'>
                <img src={`https://riymay.com/assets/${item.productUrl}`} alt="dummy-image" className="order-history-product-image" />
              </div>
              <div className='order-history-product-text'>
                <h3 className="order-history-item-name"> {item.productName.substring(0,25)}{item.productName.length > 25 ? "..." : ""}</h3>
                {/* <p className="order-history-item-id"><strong>Product ID:</strong> {item.productId}</p> */}
                <p className="order-history-item-quantity"><strong>Quantity:</strong> {item.quantity}</p>
                {/* <p className="order-history-item-unit-price"><strong>Unit Price:</strong> ₹{item.unitPrice}</p> */}
                <p className="order-history-item-total-price"><strong>Total Unit Price :</strong> ₹{(item.totalPrice - item.discountAmount)}/-</p>

                {/* <p className="order-history-item-total-price"><strong>Unit Price :</strong> ₹{item.unitPrice }/-</p> */}
                {/* <p className="order-history-item-total-price"><strong>Discount Applied :</strong> ₹{(item.discountAmount)}/-</p> */}
                <p className="">Size : <span className='order-history-item-siz'>{item.size}</span>  </p>
                <p className="">Status: <span className='order-history-status'>{order.orderInfo.orderStatus}</span></p>
                {/* <p className="order-history-payment-status">Payment {order.orderInfo.orderPaymentStatus}</p> */}
                {/* <h3 className="order-history-order-id">Order ID: {order.orderInfo._id}</h3> */}
                <div className='order-history-review' onClick={() => handleWriteReview(item.productId)}>
                  <span>write review...</span>
                </div>
              </div>
             
              
            </div>
              
              
              {/* <div className="order-history-card-footer">
                <h4 className="order-history-shipping-header">Shipping Information</h4>
                

                {order.orderShippingInfo.orderShippingAddress.map((address, addrIndex) => (
                  <div className="order-history-address" key={addrIndex}>
                    <p className="order-history-address-street"><strong>Street:</strong> {address.street}</p>
                    <p className="order-history-address-city"><strong>City:</strong> {address.city}</p>
                    <p className="order-history-address-state"><strong>State:</strong> {address.state}</p>
                    <p className="order-history-address-pin"><strong>Pin Code:</strong> {address.pinCode}</p>
                    <p className="order-history-expected-delivery"><strong>Expected Delivery:</strong> {order.orderShippingInfo.expectedDeliveryDate}</p>
                  </div>
                ))}
              </div> */}

<div className="order-details">
<h4>Order Details:</h4>
<div className="totals">
            <p>Invoice Number:<stong>{order.orderInfo.razorpayOrderId}</stong> </p>
            <p>Order Date:<strong>{new Date(order.orderInfo.orderPlacedDate).toDateString()}</strong> </p>
            <p>
              Shipping Address:{" "}
              {order.orderShippingInfo.orderShippingAddress.map((addr) => (
                <div key={addr._id}>
                  <strong> {addr.street},  {addr.city},</strong><br/>
                  <strong>{addr.state} - {addr.pinCode},{" "}
                  {addr.country}</strong>
                </div>
              ))}
            </p>
            </div>
            <div className="timeline-container">
  {/* Order Placed Step */}
  <div className={`timeline-step ${order.orderInfo.orderPlacedDate ? 'active' : ''}`}>
    <div className="step-indicator"></div>
    <div className="step-content">
      <strong>Order Confirmed</strong>
      <br />
      <span>
        {new Date(order.orderInfo.orderPlacedDate).toLocaleDateString('en-US', {
          weekday: 'short',
          day: 'numeric',
          month: 'short',
        })}
      </span>
    </div>
  </div>
  
  <div className="timeline-bar"></div>

  {/* Out for Delivery Step */}
  <div className={`timeline-step ${
    order.orderInfo.orderStatus === 'out_for_delivery' || 
    order.orderInfo.orderStatus === 'completed' ? 'active' : ''
  }`}>
    <div className="step-indicator"></div>
    <div className="step-content">
      <strong>Out for Delivery</strong>
      <br />
      <span>
        {order.orderShippingInfo.OutForDeliveryDate
          ? new Date(order.orderShippingInfo.OutForDeliveryDate).toLocaleDateString('en-US', {
              weekday: 'short',
              day: 'numeric',
              month: 'short',
            })
          : order.orderInfo.orderStatus === 'out_for_delivery' || 
            order.orderInfo.orderStatus === 'completed'
            ? 'In Progress'
            : ''
        }
      </span>
    </div>
  </div>
  
  <div className="timeline-bar"></div>

  {/* Delivered Step */}
  <div className={`timeline-step ${
    order.orderInfo.orderStatus === 'completed' ? 'active' : ''
  }`}>
    <div className="step-indicator"></div>
    <div className="step-content">
      <strong>Delivered</strong>
      <br />
      <span>
        {order.orderShippingInfo.DeliveryCompletedDate
          ? new Date(order.orderShippingInfo.DeliveryCompletedDate).toLocaleDateString('en-US', {
              weekday: 'short',
              day: 'numeric',
              month: 'short',
            })
          : order.orderInfo.orderStatus === 'completed'
            ? 'Completed'
            : ''
        }
      </span>
    </div>
  </div>
</div>
            <div className="totals">
              <p>
                Total: <span>₹ {order.orderInfo.totalOrderAmount}</span>
              </p>
              <p>
                Discount: <span>₹ {order.orderItems[0]?.discountAmount}</span>
              </p>
              <p>
                Delivery Charges:{" "}
                <span>
                  {order.orderShippingInfo.deliveryCharges === 0
                    ? "Free"
                    : `₹ ${order.orderShippingInfo.deliveryCharges}`}
                </span>
              </p>
            </div>
            <div className="total-paid">
              <h3>
                Total Paid:{" "}
                <span>
                  ₹
                  {order.orderInfo.totalOrderAmount -
                    order.orderItems[0]?.discountAmount}
                </span>
              </h3>
            </div>
          </div>
            </div>
          )))
          :
          (<div>
            <NoData />
            </div>
          )
        }
        </div>
      )))
    )
  :
  (<NoData />)}
    </div>
    {modalOpen && (
        <ReviewModal
          productId={selectedProductId}
          onClose={() => setModalOpen(false)}
        />
      )}
    </>
  );
};

export default OrderHistory;